import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    token: null,
    isHydrated: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
        },
        hydrate: (state) => {
            state.isHydrated = true;
        },
    },
});

export const { login, logout, hydrate } = authSlice.actions;
export default authSlice.reducer;
